import * as React from "react";

function SvgVideoPopupIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18.2 0H1.8C.8 0 0 .8 0 1.8v16.3c0 1 .8 1.8 1.8 1.8h16.3c1 0 1.8-.8 1.8-1.8V1.8c.1-1-.7-1.8-1.7-1.8zM1.8 1.5h16.3c.2 0 .3.1.3.3V13h-17V1.8c.1-.2.3-.3.4-.3zm16.4 17H1.8c-.2 0-.3-.1-.3-.3v-3.7h17v3.7c0 .2-.1.3-.3.3zm-11-7.2c.2.1.5.1.8 0L13.5 8c.2-.1.4-.4.4-.6 0-.3-.1-.5-.4-.6L7.9 3.4c-.2-.1-.5-.1-.8 0-.2.1-.3.3-.3.6v6.6c0 .3.1.5.4.7zm1.1-6l3.4 2-3.4 2v-4zm9 11.2c0 .4-.3.8-.8.8H3.4c-.4 0-.8-.3-.8-.8 0-.4.3-.8.8-.8h13.2c.4 0 .7.3.7.8z" /></svg>;
}

export default SvgVideoPopupIcon;